import type { FuncOverrideComponent } from '../theme.types';

export const MuiTextField: FuncOverrideComponent<'MuiTextField'> = () => ({
  defaultProps: {
    variant: 'outlined',
  },
});
